import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/dJxML6sdS9Vd1dGLitULgq/ChatGPT_Image_6_sept_2026,_19_08_55.png';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-58" data-mp="4lyw0o28qiep">
      <div className="relative mx-auto w-full max-w-content px-5 pb-8 pt-5 sm:px-8 sm:pb-12 sm:pt-8" data-id="element-59" data-mp="4njnu5x67n8v">
        <p className="text-center font-serif text-[0.7rem] uppercase tracking-label text-forest" data-id="element-60" data-mp="127eereur1rdz">
          Yoga Teacher System<sup className="text-[0.55em]" data-id="element-61" data-mp="sbb23f29uacs">™</sup>
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-3 max-w-3xl text-center" data-id="element-62" data-mp="s9q6rn84undv">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-gold/40 bg-ivory px-3.5 py-1.5 text-[0.58rem] font-semibold uppercase tracking-label text-gold sm:text-[0.65rem]" data-id="element-63" data-mp="382fdzkwc8ydc">
            <StarIcon className="h-3 w-3 fill-gold text-gold" aria-hidden="true" data-id="element-64" data-mp="3o7lq5lizewmb" />
            Complete Ready-to-Teach System
          </span>

          <h1 className="mt-3 font-serif text-[1.7rem] font-semibold uppercase leading-[1.05] tracking-tight text-ink sm:text-[2.75rem] lg:text-5xl" data-id="element-65" data-mp="399jmzcfv4d5l">
            The complete Ready-to-Teach system
            <span className="block text-forest" data-id="element-66" data-mp="30gztsricb0s5">for yoga teachers</span>
          </h1>

          <p className="mx-auto mt-3 max-w-xl text-[0.9rem] leading-snug text-muted sm:text-base" data-id="element-67" data-mp="358zoo5jjz3hv">
            Stop spending hours planning sequences, choosing poses, organizing transitions,
            preparing modifications and wondering what you’re going to teach in your next class.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} src={MOCKUP} alt="Yoga Teacher System — the six volume covers of the Ready-to-Teach class library" className="mx-auto mt-3 w-full max-w-4xl sm:mt-5" width={1536} height={1024} data-id="element-68" data-mp="2hjoyfhztwrhz" />

        <p className="text-center font-serif text-sm uppercase tracking-label text-forest sm:text-lg" data-id="element-69" data-mp="i9vqb23hxwks">
          Open <span className="text-gold" data-id="element-70" data-mp="1b0vw9ile1af3">•</span> Choose <span className="text-gold" data-id="element-71" data-mp="1azulzgc74ryf">•</span> Teach
        </p>

        <div className="mt-5" data-id="element-72" data-mp="1622hlmud7ddc">
          <CtaButton label="Get the complete Yoga Teacher System" microcopy="120 Ready-to-Teach Classes • Instant Access • One-Time Purchase" data-id="element-73" data-mp="162ugb6j9dr7u" />
        </div>
      </div>
    </header>;
}